import React from "react";

export default function(props) {
    return (
        <div style={{ textAlign: "center", fontSize: "12px" }}>
            Create Conversation
        </div>
    );
}
